import { RequisitionStatusDataModel } from "./requisition-status-data.model";

export class RequisitionStatusSummaryModel {
    totalDraft: number = 0;
    totalSubmitted: number = 0;
    totalProcessing: number = 0;
    totalCompleted: number = 0;
    totalIncompleted: number = 0;
    totalMonths: number = 0;
    from?: Date;
    to?: Date;
    yAxisMaxTotal?: number;
    data?: RequisitionStatusDataModel[];
    name?: string;
    categoryValue?: number;
}
